import React, { useEffect, useRef, useState } from 'react';
import {
    Navbar,
    Nav,
    Container
} from 'react-bootstrap';
import { useApp } from '../../hooks/AppHooks';
import './style.scss';
import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';

interface Props {
    window?: () => Window;
}

const HeaderC: React.FC<Props> = () => {
    const { homeEnglishData } = useApp();
    const dataItem = homeEnglishData?.home?.header;
    const [currentActive, setCurrentActive] = useState<number | null>(null);
    const [headerShow, setHeaderShow] = useState(false);
    const prevScrollPos = useRef(0);
    const checkboxRef = useRef<HTMLInputElement>(null); // Reference to the checkbox
    const headerRef = useRef<HTMLDivElement>(null); // Reference to the header container
    const [checkTrue, setCheckTrue] = useState(false);

    useEffect(() => {
        const savedIndex = localStorage.getItem('activeIndex');
        if (savedIndex !== null) {
            setCurrentActive(Number(savedIndex));
        }
    }, []);

    useEffect(() => {
        const toggleVisibility = () => {
            const currentScrollPos = window.pageYOffset;
            if (currentScrollPos > 0 && currentScrollPos > prevScrollPos.current) {
                setHeaderShow(false); // Automatically hide header when scrolling down
                if (checkboxRef.current) {
                    checkboxRef.current.checked = false; // Uncheck the checkbox
                }
            }
            prevScrollPos.current = currentScrollPos;
        };

        window.addEventListener("scroll", toggleVisibility);

        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                headerRef.current &&
                !headerRef.current.contains(event.target as Node) &&
                checkboxRef.current &&
                checkboxRef.current.checked
            ) {
                // If clicking outside of header and checkbox is checked, close the menu
                checkboxRef.current.checked = false;
                setHeaderShow(false);
                setCheckTrue(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const onClickHeaderToggle = (event: any) => {
        const isChecked = event.target.checked;
        setHeaderShow(isChecked);
        setCheckTrue(isChecked);
    };

    const onClickHandlerHide = () => {
        setCheckTrue(false);
        setHeaderShow(false);
        if (checkboxRef.current) {
            checkboxRef.current.checked = false; // Uncheck the checkbox
        }
    };

    const renderTooltip = (props: any) => (
        <Tooltip id="button-tooltip" {...props}>
            Menu
        </Tooltip>
    );

    return (
        <div className="header-section" ref={headerRef}>
            <Container className='cubedots-logo'>
                <Link to="/"><img src='./assets/images/logo.png' alt="Footer Logo" width={'40px'} /></Link>
                <OverlayTrigger
                    placement="left"
                    overlay={renderTooltip}
                >
                    <div className='burger-box'>
                        <label className={`burger ${checkTrue ? "burger1" : ""}`} htmlFor="burger">
                            <input
                                ref={checkboxRef}
                                onClick={onClickHeaderToggle}
                                type="checkbox"
                                id="burger"
                            />
                            <span></span>
                            <span></span>
                            <span></span>
                        </label>
                    </div>
                </OverlayTrigger>
            </Container>
            <Navbar bg="dark" variant="dark" expand="lg" fixed="top" style={{ transition: "0.5s", transform: !headerShow ? "translate(100%, 0%)" : "translate(0%, 0)" }}>
                <Container>
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="me-auto">
                            {dataItem?.menu?.map((item: any, index: number) => (
                                <div key={index} className={`menu-items menu-class${index}${currentActive === index ? ' active' : ''}`}>
                                    <NavLink
                                        onClick={onClickHandlerHide}
                                        to={item.link}
                                    >
                                        {item.menuItems}
                                    </NavLink>
                                </div>
                            ))}
                            <div id="google_translate_element" style={{ width: '136px' }}></div>
                        </Nav>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
        </div>
    );
};

export default HeaderC;
